import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthenticationServiceImpl } from './authentication-service-impl.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],
})
export class AuthenticationComponent implements OnInit {
  sanitizedUrl: SafeResourceUrl | undefined;

  constructor(
    private sanitizer: DomSanitizer,
    private authenticationService: AuthenticationServiceImpl,
    @Inject('oauthApiUrl') private oauthApiUrl: string,
    @Inject('oauthClientId') private oauthClientId: string,
    @Inject('oauthScopes') private oauthScopes: string,
    @Inject('oauthRedirectUrl') private oauthRedirectUrl: string
  ) {}

  public ngOnInit(): void {
    this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      [
        this.oauthApiUrl,
        '/acs2/iframe?client_id=',
        this.oauthClientId,
        '&scope=',
        this.oauthScopes,
        '&redirect_uri=',
        this.oauthRedirectUrl,
          '&target=',
          environment.cloudTarget,
      ].join('')
    );
  }

  @HostListener('window:message', ['$event'])
  receiveToken(event: MessageEvent): void {
    if (String(event.data).indexOf('Bearer') === -1) {
      return;
    }
    this.authenticationService.receiveToken(event.data);
  }
}
